import { Snackbar as MuiSnackbar, SnackbarProps, styled } from '@mui/material';

export const Snackbar = styled((props: SnackbarProps) => (
  <MuiSnackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} {...props} />
))({
  position: 'fixed',
  left: '50%',
  transform: 'translateX(-50%)',
});
